<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-select
            size="small"
            ref="selectGame"
            v-model="game"
            filterable
            remote
            reserve-keyword
            placeholder="游戏名称"
            @change="handleSelect3"
            :remote-method="loadGame"
            @visible-change="cancelReadOnly"
        >
          <el-option
              v-for="item in restaurants"
              :key="item.key"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="queryField.money" placeholder="金额>="></el-input>
        <el-input v-model="queryField.order_service_id" placeholder="区服id"></el-input>
        <el-date-picker
            v-model="dateValue"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
            @change="onDataConfirm">
        </el-date-picker>
        <el-button size="small" type="primary" @click="loadData(1)" :loading="isLoading">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </el-row>

      <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%"
                id="rebateSetTable">
        <el-table-column
            prop="user_id"
            label="用户id"
            width="80">
        </el-table-column>
        <el-table-column
            prop="game_id"
            label="游戏id"
            width="80">
        </el-table-column>
        <el-table-column
            prop="game_name"
            label="游戏名称"
            width="150">
        </el-table-column>
        <el-table-column
            prop="allAmount"
            label="充值金额"
            width="120">
        </el-table-column>
      </el-table>

      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="15"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {loadGame, queryUserOrder} from "@/api/request";

export default {
  name: "userOrder",
  data(){
    return {
      dateValue: "",
      game: "",
      queryField: {
        game_id: '',
        start_time: '',
        end_time: '',
        money: '',
        order_service_id: '',
      },
      tableData: [],
      currentIndex: 1,
      total: 0,
      height: window.innerHeight - 210,
      restaurants: [],
      isLoading: false,
    }
  },
  mounted() {
    this.startTimeSet();
    this.loadData(1);
  },
  methods: {
    loadData(index){
      let params = {
        pageNo: index,
        pageSize: 15,
        params: this.queryField
      }
      this.isLoading = true;
      queryUserOrder(params).then(res => {
        this.tableData = res.data.list;
        this.currentIndex = index;
        this.total = res.data.total;
      }).finally(() => {
        this.isLoading = false;
      })
    },
    loadGame(query){
      if (query !== '') {
        let me = this;
        loadGame(query).then(res => {
          me.restaurants = [];
          res.data.data.forEach(function (e) {
            let item = {}
            item.key = e.game_id
            item.value = e.game_id
            item.label = e.game_name
            me.restaurants.push(item)
          })
        })
      }
    },
    handleSelect3(item){
      this.queryField.game_id = item
    },
    cancelReadOnly(value){
      this.$nextTick(() => {
        if (!value) {
          const {selectGame} = this.$refs;
          const input = selectGame.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          this.$refs.selectGame.blur();
        }
      });
    },
    startTimeSet(){
      let now = new Date();
      let sevenDaysAgo = this.formatDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() -7))
      let today = this.formatDate(now);
      
      this.queryField.start_time = sevenDaysAgo + " 00:00:00";
      this.queryField.end_time = today + ' 23:59:59';
      this.dateValue = [this.queryField.start_time,this.queryField.end_time];
    },
    formatDate(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }
      return (y + '-' + m + '-' + d);
    },
    onDataConfirm(){
      if(this.dateValue !== null){
        this.queryField.start_time = this.dateValue[0];
        this.queryField.end_time = this.dateValue[1];
      }else {
        this.queryField.start_time = "";
        this.queryField.end_time = "";
      }
    },
    reset(){
      this.queryField = {
        game_id: '',
        start_time: '',
        end_time: ''
      }
      this.game = '';
      this.dateValue = '';
    }
  }
}
</script>

<style scoped>

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  
  .is-active{
    background-color: transparent !important;
  }
  
  /deep/ .el-date-editor .el-range__icon,
  /deep/ .el-date-editor .el-range-separator,
  /deep/ .el-date-editor .el-range__close-icon{
    line-height: 24px;
  }
</style>